module.exports = __webpack_public_path__ + "static/media/3442e310-a26d-486d-8e5e-ea4c1e15237c.1f38e731.JPG";